import reducer from './reducer'

import * as attachmentsOperations from './operations'
import * as attachmentsSelectors from './selectors'

export { attachmentsOperations, attachmentsSelectors }

export default reducer
